import React, { ReactElement } from 'react';

export default function Down (props: {
    className?: string;
}): ReactElement {
    const { className } = props;

    return (
        <svg className={className} fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
            <path d='M7 10L11.6464 14.6464C11.8417 14.8417 12.1583 14.8417 12.3536 14.6464L17 10' stroke='black' strokeLinecap='round' />
        </svg>
    );
}

